// @flow
import {
  getClosestPartialUpdateSettings, getElementPartialUpdateSettings,
  getGlobalPartialUpdateSettings, getPaginationSubmitData,
  PartialUpdateSettings,
} from './PartialUpdateSettings';
import $ from 'jquery';
import {
  getCleanUrl,
  getComposedUrl, getDynamicAreaIdWithoutContext,
  getFileInputs,
  getParentPartialUpdateContainer,
  getRequestTarget,
  getTarget,
  getTargets,
  isButtonElement,
  isMultipart,
  parsePartialUpdateSettingsFromUrl,
  parseResultsFromAjaxResult,
  removeDataFromUrl,
  removeFormIdFromData,
  removeFormIdFromUrl,
} from './partialUpdateUtils';
import { abortXHR, addXHR, removeXHR } from './XHRQueue';
import { clearChangedFlagForContainedForm, containsChangedForm } from './formsChangesChecker';
import Uri from 'urijs';
import { normalizeUrl } from '../lib/urlAndLink';
import { decorateInnerElements, disposeInnerComponents } from '../webComponents/decorate';
import { dispatchEvent, getFocusAnchor, setFocusAnchor } from '../lib/dom';
import {
  mapToSubmitDataIfNeeded,
  mergeSubmitData,
  removeFromData,
  serializeForms,
} from '../lib/form';


export const throwPUError = ({
  message,
  settings,
  jqXHR,
  textStatus,
  errorThrown,
}) => {
  const globalPUSettings = getGlobalPartialUpdateSettings();
  const onError = settings.onError || globalPUSettings.onError;
  if (onError) {
    onError({
      message,
      settings,
      globalPUSettings,
      jqXHR,
      xhr: jqXHR,
      textStatus,
      errorThrown,
    });
    throw new Error(message);
  } else {
    throw new Error(message);
  }
};

let replaceStartTime;
let disposeTime;
export const partialUpdateBeforeReplaceContents = (settings: PartialUpdateSettings, skip: ?Array<string>) => {
  const { targetElement } = settings;
  const measureDecorating = window.measurePerformance;
  replaceStartTime = new Date().getTime();
  // použito pouze v Edeem
  const existsEdeeDecorateMethods = window.fg && window.fg.ui && window.fg.ui.decorate;
  if (existsEdeeDecorateMethods) {
    window.fg.ui.decorate.disposeDecoratedComponents(targetElement, undefined, skip);
/*    ownerEdeeComponent =
      ownerEdeeComponent ||
      window.fg.ui.decorate.getDecoratedOwnerComponent(targetElement);*/
  } else {
    disposeInnerComponents(targetElement, skip);
  }

  disposeTime = new Date().getTime() - replaceStartTime;
  if (measureDecorating) {
    // eslint-disable-next-line
    console.log(`Dispose time: ${disposeTime}`);
  }

  // použito pouze v Edeem
  // vymazat frontu inline funkcí
  // fronta funkcí je potřeba volat až po nadekorování všech elementů, aby bylo možno si getnout
  // instance komponent
  if (existsEdeeDecorateMethods) {
    window.q = [];
  }
};

export const partialUpdateCalculateResultForReplacing = (props) => {
  let { targetElement, result, settings } = props;


  let { ownerEdeeComponent, requestTarget } = settings;
  const { originalTarget, omit } = settings;
  const target = getTarget(settings);
  const requestTargetWithoutContext = requestTarget
    ? getDynamicAreaIdWithoutContext(requestTarget)
    : null;
  const originalTargetWithoutContext = originalTarget ?
    getDynamicAreaIdWithoutContext(originalTarget) :
    null;

  const computedRequestTarget = requestTarget === originalTarget ? target : getRequestTarget(settings);


  const actTarget = targetElement.getAttribute('id');

  // pokud je suppressRedirect==true, tak se ze serveru vrátí kompletní HTML i s HEAD a BODY a
  // znovu se nalinkují a vykonají všechny javascripty. V následujícím kodu se response text omezí
  // pouze na požadovaný
  // div snipet of code is from jQuery.load Create a dummy div to hold the results
  if (result.lastIndexOf('<!DOCTYPE', 0) === 0) {
    const rscript = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
    result = result.replace(rscript, '');
    result = $('<div>')
    // inject the contents of the document in, removing the scripts
    // to avoid any 'Permission Denied' errors in IE
      .append(result)
      // Locate the specified elements
      .find(`#${computedRequestTarget || getTarget(settings) || actTarget}`);
  }

  result = $(result);
  if (result.length === 0) {
    // throw Error bez přerušení běhu kodu
    const responseError = new Error(
      `In server response wasn't find element with id
      attribute "${computedRequestTarget || getTarget(settings) || actTarget}".`);
    setTimeout(() => {
      throw responseError;
    }, 0);
    // aby nepřestal web správně fungovat, tak se vytvoří div element s požadovaným id
    result = $(`<div id="${target || actTarget}"></div>`);
  }

  result.attr('id', target || actTarget);


  if (computedRequestTarget && requestTargetWithoutContext !== originalTargetWithoutContext) {
    result.attr('data-partial-update-request-target', computedRequestTarget);
  }

  if (omit && omit.length > 0) {
    omit.forEach((omitSelector) => {
      const inResult = result.find(omitSelector);
      const inDOM = $(targetElement).find(omitSelector).clone();
      if (inDOM.length > 0 && inResult.length > 0) {
        inResult.replaceWith(inDOM);
      }
    });
  }
/*  if (result[0].nodeType !== 1 || result[0] == null) {
    throw new Error('Něco je v response špatně. První element z response není Element. Zkontroluj response ze serveru.');
  }*/
  return result;
};



export const partialUpdateAfterReplaceContents = (props: Object, result: JQuery|Element, skip: ?Array<string>): void => {
  const { focusAnchor, settings: { persistFocus } } = props;
  if (persistFocus) {
    setFocusAnchor(focusAnchor);
  }

  const results = (result instanceof $ ? result.toArray() : [result]).filter((element) => {
    return element.nodeType === 1;
  });
  const measureDecorating = window.measurePerformance;

  const existsEdeeDecorateMethods = window.fg && window.fg.ui && window.fg.ui.decorate;
  results.forEach((element) => {
    if (existsEdeeDecorateMethods) {
      window.fg.ui.decorate.decorateInnerElements(element, undefined, true, skip);
    } else {
      decorateInnerElements(element, skip);
    }
  });

  // TODO použito pouze v Edeem
  if (window.q) {
    window.q.forEach((f) => {
      f();
    });
    window.q = [];
  }
  const decorateTime = new Date().getTime() - replaceStartTime;
  if (measureDecorating) {
    // eslint-disable-next-line
    console.log(`Decorating time: ${decorateTime - disposeTime - replaceTime}`);
    // eslint-disable-next-line
    console.log(`Decorating time all: ${decorateTime}`);
  }

  const {
    settings: {
      scroll,
      scrollDuration,
      scrollOffset,
    },
  } = props;
  if (scroll) {
    const yPosition = $(result).offset()[scroll === true ? 'top' : scroll];
    $('html, body').animate({ scrollTop: yPosition - scrollOffset }, scrollDuration);
  }
};

let replaceTime = 0;
const replaceContents = (props) => {
  const {
    targetElement,
    settings: {
      pick,
    },
  } = props;

  const result = partialUpdateCalculateResultForReplacing(props);

  if (pick && pick.length > 0) {
    pick.forEach((selector) => {
      const newElement = $(`${selector}`, result);
      const newTargetEl = $(`${selector}`, targetElement);
      if (newTargetEl[0]) {
        partialUpdateBeforeReplaceContents({
          targetElement: newTargetEl[0],
        });
      }
      newTargetEl.replaceWith(newElement);
      partialUpdateAfterReplaceContents(props, newElement);
    });
  } else {
    partialUpdateBeforeReplaceContents(props);
    $(targetElement).replaceWith(result);
    replaceTime = new Date().getTime() - disposeTime - replaceStartTime;

    const measureDecorating = window.measurePerformance;
    if (measureDecorating) {
      // eslint-disable-next-line
      console.log(`Replace time: ${replaceTime}`);
    }
    partialUpdateAfterReplaceContents(props, result);
  }

};

const scrollIfScrollAnchorExists = (element: JQuery): void => {
  const anchorElement = element.closest('.partial-update-scroll-anchor');
  if (anchorElement.length > 0) {
    const fixedOffset = anchorElement.attr('data-partial-update-scroll-fixed-offset');
    const wantedScrollTop =
      anchorElement.offset().top + (fixedOffset ? parseInt(fixedOffset, 10) : 0);
    if ($(window).scrollTop() > wantedScrollTop) {
      $('html, body').animate({
        scrollTop: wantedScrollTop,
      }, 250);
    }
  }
};

const getTargetElement = (settings: PartialUpdateSettings): Element => {
  const target = getTarget(settings);
  // TODO JNO zapřičiňuje load ze serveru pouze base componenty. Proto jsem zakomentoval
  /* const containerCnt = $(`#${target}__container`);
  if (containerCnt.length > 0) {
    // prefer container elements before target ones
    elementId = `${target}__container`;
  } else {
    // elementId = target;
   } */
  const targetElement = document.getElementById(target);
  if (targetElement == null) {
    abortXHR(target);
    throwPUError({
      message: `Cannot perform partial update of the container id ${target} is not present.`,
      settings,
    });
  }
  return targetElement;
};

const handleSuccess = ({
  result,
  settings,
  textStatus,
  jqXHR,
}) => {
  const { target, containerId } = settings;
  const originalTarget = target || containerId;
  const targets = getTargets(settings);
  /*  let targets = containerId || target;
  if (!Array.isArray(targets)) {
    targets.replace(/,/g, '+');
    targets = targets.split('+');
  } */
  const newAccessibleTargets = [];
  const results = parseResultsFromAjaxResult(settings, result);
  targets.forEach((simpleTarget) => {
    // settings with simple target
    settings = {
      ...settings,
      target: simpleTarget,
      originalTarget,
      containerId: null,
    };
    result = results[simpleTarget];
    const targetElement = getTargetElement(settings);

    const beforeContentsReplacedEvent = dispatchEvent(
      targetElement,
      'beforeContentsReplaced',
      {
        result,
        textStatus,
        xhr: jqXHR,
        settings,
        targetElement,
      },
    );
    if (settings.onBeforeContentsReplaced) {
      settings.onBeforeContentsReplaced({
        result,
        settings,
        xhr: jqXHR,
        textStatus,
        targetElement,
      });
    }
    let newAccessibleTarget = null;


    if (!beforeContentsReplacedEvent.defaultPrevented) {
      try {
        (
          settings.replaceContents || replaceContents
        )({
          targetElement,
          result,
          settings,
          xhr: jqXHR,
          textStatus,
          focusAnchor: getFocusAnchor(),
        });
      } catch (e) {
        // throw Error bez přerušení běhu kodu
        setTimeout(() => {
          throw e;
        }, 0);
      }

      newAccessibleTarget = $(document.getElementById(targetElement.getAttribute('id')));
      if (newAccessibleTarget.length > 0) {
        scrollIfScrollAnchorExists(newAccessibleTarget);
        if (settings.onAfterContentsReplace) {
          settings.onAfterContentsReplace({
            targetElement,
            newAccessibleTarget: newAccessibleTarget[0],
            result,
            settings,
            jqXHR,
            xhr: jqXHR,
            textStatus,
          });
        }

        dispatchEvent(
          newAccessibleTarget[0],
          'afterContentsReplaced',
          {
            settings,
            result,
            textStatus,
            xhr: jqXHR,
            targetElement,
            newAccessibleTarget: newAccessibleTarget[0],
          },
        );
      }
    }
    newAccessibleTargets.push(newAccessibleTarget);
  });

  return newAccessibleTargets;
};

export const composeAjaxSettings = (
  predefinedAjaxSettings: Object,
  partialUpdateSettings: PartialUpdateSettings,
  form: ?JQuery,
  button: ?JQuery,
  contextElement: ?JQuery,
): Object => {
  const target = getTarget(partialUpdateSettings);
  const globalPUSettings = getGlobalPartialUpdateSettings();
  if (partialUpdateSettings.data) {
    partialUpdateSettings.data = mapToSubmitDataIfNeeded(partialUpdateSettings.data);
  }

  const puSettingsMergedWithGlobal = {
    ...globalPUSettings,
    ...partialUpdateSettings,
  };
  contextElement = contextElement || $(window.document.body);

  let {
    url,
    removeContainerWidgetData,
    requestTarget,
    eventName,
    type,
  } = puSettingsMergedWithGlobal;

  const {
    ajax,
    alterHistory,
    data,
    dataMerge,
    historyScope,
    layoutContext,
    removeFormWidgetData,
    suppressRedirect,
    dataType,
    command,
    exceptParams,
    removeFormId,
    rememberPagination,
    dataFromAllFormsInDocument,
    moveUrlQueryParamsToFormDataOnPost,
    headers,
  } = puSettingsMergedWithGlobal;

  let computedData = [];
  const composedSettings = {};

  if (dataType) {
    composedSettings.dataType = dataType;
  }

  if (type) {
    type = type.toUpperCase();
    composedSettings.type = type;
  }

  eventName = command || eventName;

  if (form && form.length > 0) {
    const formPartialUpdateUrl = form.data('partialUpdateUrl');
    url = url || formPartialUpdateUrl || form.attr('action');
    requestTarget = getRequestTarget(puSettingsMergedWithGlobal) || target || form.attr('id');

    const formParentPUContainer = getParentPartialUpdateContainer(form[0]);

    // na server se pošlou všechna data z formulářů v jsPartialUpdate konteineru,
    // které mají stejný atribut action
    const forms = dataFromAllFormsInDocument && formParentPUContainer ? formParentPUContainer.querySelectorAll(`form[action="${form.attr('action')}"]`) : [form[0]];
    computedData = serializeForms(forms);

    computedData = removeFromData(computedData, removeFormWidgetData, true);
    if (removeFormId) {
      computedData = removeFormIdFromData(computedData);
    }
    url = removeDataFromUrl(url, removeFormWidgetData, true);
  } else {
    requestTarget = getRequestTarget(puSettingsMergedWithGlobal) || target;
  }
  if (target && removeContainerWidgetData) {
    if (removeContainerWidgetData === true) {
      const container = $(`#${target}`, contextElement);
      removeContainerWidgetData = container
        .find('[name^="frm."]')
        .toArray()
        .map((input) => input.name.replace('frm.', ''));
    }
    computedData = removeFromData(computedData, removeContainerWidgetData, true);
    url = removeDataFromUrl(url, removeContainerWidgetData, true);
  }


  computedData = removeFromData(computedData, exceptParams, false);
  if (url) {
    url = removeDataFromUrl(url, exceptParams, false);
    if (removeFormId) {
      url = removeFormIdFromUrl(url);
    }
    url = getComposedUrl(url, requestTarget);
  }
  if (moveUrlQueryParamsToFormDataOnPost && type === 'POST' && url) {
    const uri = new Uri(url);
    const queryData = Uri.parseQuery(uri.query());
    url = uri.search('').toString();
    computedData = [...computedData, ...mapToSubmitDataIfNeeded(queryData)];
  }


  if (data) {
    computedData = [...computedData, ...mapToSubmitDataIfNeeded(data)];
  }
  if (dataMerge) {
    computedData =
      mergeSubmitData(computedData, dataMerge);
  }

  if (suppressRedirect) {
    computedData.push({
      name: 'RamJet-Suppress-Redirect',
      value: 'true',
    });
  }
  if (alterHistory) {
    computedData.push({
      name: 'RamJet-HistoryScope-Level',
      value: historyScope,
    });
  }

  if (layoutContext) {
    computedData.push({
      name: 'ramJetLayoutContext',
      value: layoutContext,
    });
  }


  if (ajax && ajax.data) {
    computedData = [...mapToSubmitDataIfNeeded(ajax.data), ...computedData];
  }

  if (eventName) {
    computedData.push({
      name: eventName.startsWith('eventName.') ? eventName : `eventName.${eventName}`,
      value: '',
    });
  }

  if (rememberPagination) {
    computedData =
      mergeSubmitData(computedData, getPaginationSubmitData(puSettingsMergedWithGlobal));
  }

  // musí být na konci po všech výpočtech nad daty

  if (button && button.length > 0) {
    const buttonNameAttribute = button.attr('name');
    const buttonEvent = {
      name: buttonNameAttribute,
      value: '',
    };

    // prevent event duplicity
    const dataNames = computedData.map((item) => item.name);
    if (!dataNames.includes(buttonNameAttribute)) {
      computedData.push(buttonEvent);
    }
  }

  if (url) {
    composedSettings.url = url;
  }

  if (headers) {
    composedSettings.headers = headers;
    if (ajax && ajax.headers) {
      composedSettings.headers = { ...headers, ...ajax.headers };
    }
  }
  if (computedData && computedData.length > 0) {
    // při POSTu nebo PUTu a pokud je ve formuláři fileinput je třeba data poslat jako FormData
    // https://stackoverflow.com/questions/45594504/upload-file-and-json-data-in-the-same-post-request-using-jquery-ajax
    // https://developer.mozilla.org/en-US/docs/Web/API/FormData/append
    if ((type === 'POST' || type === 'PUT') && form && isMultipart(form)) {
      const formData = new FormData();

      computedData.forEach(({ name, value }) => {
        formData.append(name, value);
      });

      // přidat fileInputy

      const fileInputs = getFileInputs(form);
      fileInputs.toArray().forEach((input) => {
        const name = input.getAttribute('name');
        const isMultiple = !!input.getAttribute('multiple');
        // Convert FileList to array and iterate
        [...input.files].forEach((file) => {
          formData.append(`${name}${isMultiple ? '[]' : ''}`, file, file.name);
        });
      });

      composedSettings.data = formData;
      composedSettings.contentType = false;
      composedSettings.processData = false;
      composedSettings.cache = false;
    } else {
      composedSettings.data = computedData;
    }
  }


  return {
    ...{
      cache: globalPUSettings.cache,
      timeout: globalPUSettings.timeout,
    },
    ...ajax,
    ...predefinedAjaxSettings,
    ...composedSettings,
  };
};

// obstraní hidden inputy, které byly přidány na základě property data v settings
export const removeDataInputs = (settings) => {
  const { data } = settings;
  /* if (submitId) {
    const form = $(`#${getSubmitId(settings)}`).closest('form');
    if (form.length > 0) {
      data.forEach(({ name, value }) => {
        $(`[type="hidden"][name="${name}"]`, form)
          .remove();
      });
      // remove timestamp hidden input
      $('[type="hidden"][name="_"]', form)
        .remove();
    }
  } */
  const targetElement = document.getElementById(getTarget(settings));
  if (targetElement) {
    if (data) {
      data.forEach(({ name }) => {
        $(`[type="hidden"][name="${name}"]`, targetElement)
          .remove();
      });
    }
    // remove timestamp hidden input
    $('[type="hidden"][name="_"]', targetElement)
      .remove();
  }
};

export const executeAjax = ({
  settings,
  form,
  button,
}) => {
  const target = getTarget(settings);
  const { partialUpdateType } = settings;
  const closestPuSettings = partialUpdateType === 'submit' ? getClosestPartialUpdateSettings(settings, [ 'url' ]) : getClosestPartialUpdateSettings(settings);

  settings = {
    ...getGlobalPartialUpdateSettings(),
    ...closestPuSettings,
    ...settings,
  };

  // pokud není definovaná url, tak se vezme z location
  // pouze u jiných typů než 'submit'
  if(partialUpdateType !== 'submit' && settings.url == null) {
    settings.url = window.location.href;
  }

  // normalizace url do settings
  // seřadí se parametry
  // odebere se domena
  if (settings.url) {
    const settingsUri = new Uri(normalizeUrl(settings.url));
    settings.url = settingsUri.authority('').origin('').toString();
  }

  const {
    formsChangesDetection,
    onComplete,
    alterHistory,
    onFormsChangesDetect,
    onBeforeExecute,
  } = settings;

  abortXHR(target);

  if (formsChangesDetection && onFormsChangesDetect != null && containsChangedForm(target)) {
    onFormsChangesDetect({
      settings,
    });
  } else {
    clearChangedFlagForContainedForm(target);

    const performComplete = (jqXHR, textStatus, newAccessibleTarget, settings) => {
      removeXHR(target);
      let alterHistoryUrl = null;
      let actualUrl = null;
      let actualParams = null;
      if (newAccessibleTarget && alterHistory) {
        // dopočítání url z z XHR hlaviček
        // může se využít pro zaznamenávání/manipulování historie prohlížeče
        actualUrl = jqXHR.getResponseHeader('RamJet-RequestedUrl') || settings.url;
        actualParams = jqXHR.getResponseHeader('RamJet-RequestedParameters');
        //if (!actualParams) {
/*          const targetElement = document.getElementById(getTarget(settings));
          console.log(document.getElementById(getTarget(settings)));
          const inputsScopeContainer =
            getParentPartialUpdateContainer(targetElement) ||
            document.getElementById(getTarget(settings.target));
          console.log($(inputsScopeContainer))
          console.log($(inputsScopeContainer).find('form').serializeArray())
          */
       // }
        const { data } = settings;
        if (actualUrl) {
          const actualUri = new Uri(actualUrl);
          if (actualParams) {
            actualUri.search(actualParams);
          }
          actualUri.removeSearch('_');
          if (data) {
            data.forEach(({ name }) => {
              actualUri.removeSearch(name);
            });
          }
          actualUri.authority('').origin('');
          alterHistoryUrl = getCleanUrl(actualUri.toString());
          alterHistoryUrl = removeFormIdFromUrl(alterHistoryUrl);
          // alterHistoryUrl = removeDataFromUrl(alterHistoryUrl, true, true);
          alterHistoryUrl = normalizeUrl(alterHistoryUrl);
        }
      }

      removeDataInputs(settings);

      const hasError = jqXHR.getResponseHeader('RamJet-Error') === 'true';

      const {
        layoutContext,
        url,
        onAlterHistory,
        onComplete,
      } = settings;

      // complete se volá ještě před execute innerPUsettings, které se parsuje z url
      if (newAccessibleTarget && newAccessibleTarget.length > 0) {
        dispatchEvent(
          newAccessibleTarget[0],
          'partialUpdateComplete',
          {
            settings,
            xhr: jqXHR,
            params: actualParams,
            url: actualUrl,
            alterHistoryUrl,
            newAccessibleTarget: newAccessibleTarget[0],
            hasError,
            textStatus,
          },
        );

        if (onComplete) {
          onComplete({
            xhr: jqXHR,
            settings,
            textStatus,
            alterHistoryUrl,
            hasError,
            newAccessibleTarget: newAccessibleTarget[0],
          });
        }
      }


      let innerPUsettings;

      if (url) {
        innerPUsettings = parsePartialUpdateSettingsFromUrl(url);
        if (innerPUsettings) {
          // eslint-disable-next-line
          execute({
            ...innerPUsettings,
            layoutContext,
            onAlterHistory,
            onComplete,
          });
        }
      }
      if (!innerPUsettings) {
        if (alterHistory && alterHistoryUrl && onAlterHistory) {
          onAlterHistory({
            settings,
            xhr: jqXHR,
            params: actualParams,
            url: actualUrl,
            alterHistoryUrl,
            newAccessibleTarget: newAccessibleTarget[0],
            hasError,
            textStatus,
          });
        }
      }
    };
    if (onBeforeExecute) {
      onBeforeExecute({
        settings,
      });
    }

    const ajaxSettings = composeAjaxSettings({
      success: (result, textStatus: string, jqXHR) => {
        if (window.measurePerformance) {
          // eslint-disable-next-line
          console.log(`Partial update request time: ${new Date().getTime() - ajaxStartTime}`);
        }
        if (result != null && jqXHR.status === 200) {
          if (jqXHR.getResponseHeader('FULL_PAGE_REDIRECT')) {
            window.location = jqXHR.getResponseHeader('FULL_PAGE_REDIRECT');
            return;
          }

          const newAccessibleTargets = handleSuccess({
            result,
            settings,
            jqXHR,
            textStatus,
          });
          newAccessibleTargets.forEach((newAccessibleTarget) => {
            performComplete(jqXHR, textStatus, newAccessibleTarget, settings);
          });
        } else {
          performComplete(jqXHR, textStatus, null, settings);
          throwPUError({
            message: `Server returned HTTP: ${jqXHR.status} (no partial update performed)`,
            settings,
            jqXHR,
          });
        }
      },
      error: (jqXHR, textStatus, errorThrown) => {
        performComplete(jqXHR, textStatus, null, settings);
        if (jqXHR.statusText !== 'abort') {
          throwPUError({
            message: `Server returned HTTP: ${jqXHR.status} ${textStatus} (${errorThrown}). No partial update performed.`,
            settings,
            jqXHR,
            textStatus,
            errorThrown,
          });
        }
      },
    }, settings, form, button);
    const ajaxStartTime = new Date().getTime();
    const xhr = $.ajax(ajaxSettings);
    addXHR(target, xhr, settings);
  }
};

/**
 * Vyvolá PU s vlastním nastavením.
 * Request je volán POST metodou.
 * V requestu jsou odesílána všechna form data ze všech formůlářů, které jsou v parentím
 * jsPartialUpdate Form data z formulářů které jsou mimo parentí jsPartialUpdate a jsou na stejné
 * stránce se neodesílají
 */
export const executeSubmit = (settings: PartialUpdateSettings) => {
  const {
    submitId,
  } = settings;

  const submitElement = $(`#${submitId}`);
  if (submitElement.length === 0) {
    throwPUError({
      message: `Cannot perform partial update - submit or form with id ${submitId} is not present.`,
      settings,
    });
  }
  const isForm = submitElement.is('form');
  const isButton = isButtonElement(submitElement);
  const form = isForm ? submitElement : submitElement.parents('form');

  if (form.length === 0) {
    if (submitElement.length === 0) {
      throwPUError({
        message: 'Cannot perform partial update - form not found.',
        settings,
      });
    }
  }
  const button = isButton ? submitElement : null;

  const formPartialUpdateUrl = form.data('partialUpdateUrl');
  const url = settings.url || formPartialUpdateUrl || form.attr('action');

  return executeAjax({
    settings: {
      type: 'POST',
      dataType: 'html',
      partialUpdateType: 'submit',
      // target,
      ...settings,
      url,
    },
    form,
    button,
  });
};

/**
 * Vyvolá PU s vlastním nastavením.
 * Request je volán GET.
 * Nejsou odesílána widget data
 * Pouze se odesílá url a vlastní data z nastavení data
 */
export const execute = (settings: PartialUpdateSettings) => {
  if (settings.target == null && settings.containerId == null) {
    settings.target = getGlobalPartialUpdateSettings().globalTarget;
  }

  executeAjax({
    settings: {
      type: 'GET',
      dataType: 'html',
      ...settings,
    },
  });
};

/**
 * přeruší execute partial updatu včetně přerušení XHR
 */
export const abortExecute = (settings: PartialUpdateSettings) => {
  const target = getTarget(settings);
  abortXHR(target);
};

/**
 * Doporučuji volat např. při zavírání modal dialogu
 * Zajistí destroy všech vnitřních komponent a do targetu bude nasetováno prázné HTML
 */
let puClearTimeout;
export const clear = (settings: PartialUpdateSettings) => {
  clearTimeout(clearTimeout);
  const globalPUSettings = getGlobalPartialUpdateSettings();
  settings = {
    ...globalPUSettings,
    ...settings,
    partialUpdateType: 'clear',
  };
  const target = getTarget(settings);
  const {
    formsChangesDetection,
    onFormsChangesDetect,
    onComplete,
  } = settings;
  abortXHR(target);
  const targetEl = document.getElementById(target);
  if (formsChangesDetection && onFormsChangesDetect != null && containsChangedForm(target)) {
    onFormsChangesDetect({
      settings,
    });
  } else if (targetEl) {
    const existsEdeeDecorateMethods = window.fg && window.fg.ui && window.fg.ui.decorate;
    if (existsEdeeDecorateMethods) {
      window.fg.ui.decorate.disposeDecoratedComponents(targetEl);
    } else {
      disposeInnerComponents(targetEl);
    }

    // pro vymazání HTML je potřeba dát zpoždění
    // pokud je PU použit v reactu, tak se může stát že PU by smazal elemnty dříve
    // než by se nad nimi unmoutly react komponenty
    puClearTimeout = setTimeout(() => {
      targetEl.innerHTML = '';
      if (onComplete) {
        onComplete({
          settings,
        });
      }
    }, 1);
  }
};

/**
 * Formulář se neodešle pomocí AJAXu. Ale bude odeslán do iframu nebo nového tabu prohlížeče.
 * ID iframu se definuje do target vlastnoti
 * Pokud je target _blank nebo není definovaný tak se formulář odešle do nového okna prohlížeče
 */
export const submitToIFrameOrBrowserTab = (submitSettings: PartialUpdateSettings): void => {
  const {
    submitId,
    url,
    data,
  } = submitSettings;
  let { target } = submitSettings;
  if (!target) {
    target = '_blank';
  }
  const submitElement = $(`#${submitId}`);
  if (submitElement.length === 0) {
    throwPUError({
      message: `Cannot perform submit to iframe - submit or form with id ${submitId} is not present.`,
      settings: submitSettings,
    });
  }
  const isForm = submitElement.is('form');
  const isButton = isButtonElement(submitElement);
  const form = isForm ? submitElement : submitElement.parents('form');
  if (form.length === 0) {
    throwPUError({
      message: 'Cannot perform submit to iframe - form not found.',
      settings: submitSettings,
    });
  }
  const button = isButton ? submitElement : null;
  const settings = composeAjaxSettings({}, {
    url,
    submitId,
    data,
  }, form, button);

  // TODO DRY
  // normalizace url do settings
  // seřadí se parametry
  // odebere se domena
  if (settings.url) {
    const settingsUri = new Uri(normalizeUrl(settings.url));
    settings.url = getCleanUrl(settingsUri.authority('').origin('').toString());
  }

  const actualAction = form.attr('action');
  const formElement = form[0];

  // odfiltruje inputy kter0 ve formuláři už jsou
  // potom se vyrenderují inputy které ve formuláři nejsou
  // po odeslání se dorenderované inputy smažou
  const inputsForRendering = settings.data.filter((inputAttributes) => {
    const { name } = inputAttributes;
    return formElement.querySelector(`[name="${name}"]:not(button)`) == null;
  });

  const renderedInputs = [];
  inputsForRendering.forEach(({ name, value }) => {
    const input = document.createElement('input');
    input.setAttribute('name', name);
    input.setAttribute('value', value);
    input.setAttribute('type', 'hidden');
    formElement.appendChild(input);
    renderedInputs.push(input);
  });

  form.attr('action', settings.url);
  form.attr('target', target);
  formElement.submit();
  form.attr('target', '');
  form.attr('action', actualAction);
  renderedInputs.forEach((input) => {
    formElement.removeChild(input);
  });
};

/**
 * Podle toho kde se nachází element ze vstupního parametru se automaticky
 * rozhodne jak a jakým nastavením bude PU vyvolán.
 * Do nastavení se mergne PU nastavení, které je na elementu přidáno pomocí dsata atributů.
 */
export const resolveExecute = (
  element: HTMLElement,
  customSettings: PartialUpdateSettings,
) => {
  let settings;
  if (
    customSettings == null ||
    customSettings.mergeWithTargetSettings == null ||
    customSettings.mergeWithTargetSettings === true
  ) {
    // target a request target brát pouze z elementu, na kterém resolve potřebujeme
    const closestSettingsWithoutTargetAndRequestTarget = getClosestPartialUpdateSettings(element, ['target', 'requestTarget', 'url']);

    settings = {
      ...closestSettingsWithoutTargetAndRequestTarget,
      ...getElementPartialUpdateSettings(element),
      source: element.closest('[id]').getAttribute('id'),
      ...customSettings,
    };
  } else {
    settings = customSettings || {};
  }

  const targets = getTargets(settings);

  targets.forEach((targetFromTargets) => {
    if (targetFromTargets && !document.getElementById(targetFromTargets)) {
      throwPUError({
        message: `Widget s id atributem "${targetFromTargets}" nebyl v DOMu nalezen. Prověřte, že id máte v HTML vygenerované správně.`,
        settings,
      });
    }
  });

  let { target, requestTarget } = settings;
  const { removeContainerWidgetData } = settings;

  // po kliknutí na odkaz IE11 vrací event.target jako elemnty uvnitř, je potřeba zjistit closest odkaz
  const closestHref = element.closest('a');
  const hrefUrl = closestHref ? closestHref.getAttribute('href') : null;

  const url = settings.url || hrefUrl;
  const form = element.closest('form');
  const parentPUContainer = getParentPartialUpdateContainer(element);
  const parentPUContainerId = parentPUContainer ? parentPUContainer.getAttribute('id') : null;
  const parentPUSettings = parentPUContainer ? getElementPartialUpdateSettings(parentPUContainer) : {};

  if (form && !hrefUrl && !(removeContainerWidgetData && target === form.getAttribute('id'))) {
    const formId = form.getAttribute('id');
    settings.target = target || parentPUContainerId || formId;
    settings.requestTarget = requestTarget || target || parentPUSettings.requestTarget || parentPUContainerId || formId;
    executeSubmit({
      submitId: formId,
      // alterHistory: false,
      // includeToProgress: true,
      ...settings,
    });
  } else {
    if (!target) {
      if (parentPUContainerId) {
        target = parentPUContainerId;
        if (!requestTarget) {
          requestTarget = parentPUSettings.requestTarget;
        }
      } else {
        throwPUError({
          message: 'Specifikujte pomocí data-partial-update-target atributu id elementu, který chcete aktualizovat',
          settings,
        });
      }
    }
    const closestSetting = getClosestPartialUpdateSettings(settings);
    settings.url = url || closestSetting.url;
    if (settings.removeContainerWidgetData && form) {
      let noFrmData = $('input[name]:not([name^="frm."])', form).serializeArray();
      noFrmData = noFrmData.filter(({ name }) => name !== 'formId');
      const uri = new Uri(settings.url);
      const query = {};
      noFrmData.forEach(({ name, value }) => {
        query[name] = value;
      });
      uri.addQuery(query);
      settings.url = uri.toString();
    }

    settings.target = target;
    settings.requestTarget = requestTarget || target;
    execute({
      alterHistory: false,
      // includeToProgress: true,
      ...settings,
    });
  }
};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/src/partialUpdate/partialUpdate.js